import React, { useState } from 'react';
import MovedList from './components/MovedList';
import ActionBar from '../layout/ActionBar';
import { usePageTitle } from '../../util/pageTitle';
import { useAppSelector } from '../../hooks';

function MovedTransactions() {
  usePageTitle(['Moved', 'Keys']);
  const currentUser = useAppSelector((state) => state.auth);
  const [reload, setReload] = useState<any>();

  return (
    <>
      <ActionBar />
      <MovedList reload={reload} currentUser={currentUser} />
    </>
  );
}

export default MovedTransactions;
